import angular from 'angular'
import './intro.scss'

angular.module('pub.intro', []).controller('IntroCtrl', IntroCtrl)

/** @ngInject */
function IntroCtrl($state, CacheService) {
  var vm = this

  vm.go = function() {
    var id = CacheService.getId('channelId')
    $state.go('pub.channels.sets', { parentId: id })
  }
}
